import React, { useState } from 'react';
import ListRain from './ListRain.js';
import AddRain from './AddRain.js';
import Upload from '../../shared/Upload.js';
import { ListButton, AddButton, UploadButton, DownloadButton, FAB } from '../../shared/ActionButtons';

export const Rain = ({ screen, setScreen, actions }) => {
  const [localScreen, setLocalScreen] = useState("list");

  // Use passed screen/setScreen if provided, otherwise use local state
  const currentScreen = screen !== undefined ? screen : localScreen;
  const setCurrentScreen = setScreen || setLocalScreen;

  return (
    <>
      {currentScreen === "list" && <ListRain actions={actions}/>}
      {currentScreen === "list" && <FAB onClick={() => setCurrentScreen("add")} />}
      {currentScreen !== "list" && actions && <div className="content-header">{actions}</div>}
      {(currentScreen === "add") &&
        <AddRain
          onSuccess={() => setCurrentScreen("list")}
        />
      }
      {(currentScreen === "upload") &&
        <Upload collection="rain"
          onSuccess={() => setCurrentScreen("list")}
        />
      }
    </>
  );
}

// Action buttons component for use in hub header
export const RainActions = ({ screen, setScreen }) => (
  <div className="action-buttons">
    <ListButton
      isActive={screen === "list"}
      onClick={() => setScreen("list")}
    />
    <AddButton
      isActive={screen === "add"}
      onClick={() => setScreen("add")}
    />
    <UploadButton
      isActive={screen === "upload"}
      onClick={() => setScreen("upload")}
    />
    <DownloadButton collection="rain"/>
  </div>
);

export default Rain;
